var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j-start"},[_c('btn-aperturas',{attrs:{"caja":_vm.caja}}),_c('btn-movimientos',{attrs:{"caja":_vm.caja}}),_c('btn-abrir',{attrs:{"caja":_vm.caja}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }